module.exports = __webpack_public_path__ + "img/second_zhTc.fcab6caa.png";